import React from "react";
import "./AppInput.css";

interface AppInputProps {
  id: string;
  label?: string;
  type?: string;
  value: string | number;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error?: string | undefined | boolean;
  textarea?: boolean;
  placeholder?: string;
  min?: number;
}

const AppInput: React.FC<AppInputProps> = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  error,
  textarea = false,
  placeholder = "",
  min,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      const blockedKeys = [
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown",
        "+",
        "-",
        "e",
        "E",
      ];
      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (type === "number" && inputRef.current === document.activeElement) {
      if (inputRef.current) {
        inputRef.current.blur();
      }
      e.preventDefault();
    }
  };

  const displayValue = type === "number" && value === 0 ? "" : value;

  return (
    <div className="app-input">
      {textarea ? (
        <textarea
          id={id}
          placeholder={placeholder}
          value={displayValue}
          onChange={onChange}
        />
      ) : (
        <>
          <input
            ref={inputRef}
            type={type}
            id={id}
            placeholder={placeholder}
            value={displayValue}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            onWheel={handleWheel}
            min={min}
            {...props}
          />
          {label && <label htmlFor={id}>{label}</label>}
        </>
      )}
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default AppInput;
